import React from 'react';
import HeroSection from '../components/HeroSection';
import { 
  HowItWorks, 
  LuxuryCarsSection, 
  StatsSection, 
  ServicesSection, 
  FAQSection, 
  WhyChooseUs, 
  TestimonialsSection, 
  FeaturedCollection, 
  CTASection 
} from '../components/Sections';
import FooterSection from '../components/Footer';

const HomePage = ({ cars, isDark, openBookingModal }) => (
  <>
    <HeroSection isDark={isDark} />
    <HowItWorks isDark={isDark} />
    <LuxuryCarsSection cars={cars} isDark={isDark} openBookingModal={openBookingModal} limit={6} />
    <StatsSection isDark={isDark} />
    <ServicesSection isDark={isDark} />
    <FAQSection isDark={isDark} />
    <WhyChooseUs isDark={isDark} />
    <TestimonialsSection isDark={isDark} />
    <FeaturedCollection cars={cars} isDark={isDark} openBookingModal={openBookingModal} />
    <CTASection isDark={isDark} />
    <FooterSection isDark={isDark} />
  </>
);

export default HomePage;
